import { AfterViewChecked, AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { PlaceOrderViewModel, ProcessStatus, SendTransactionToEmailBindingModel, ComputeOrderBindingModel, Payment, PlaceOrderBindingModel, ValidateGiftVoucherByNumberBindingModel } from 'src/app/api/models/web-booking.models';
import { AppConstants } from 'src/app/app.constants';
import { BaseComponent } from 'src/app/layout/main/base.component';
import { PaymentTypeGroup } from 'src/app/misc/enums';

declare let paypal: any;

@Component({
  selector: 'app-gift-voucher-redemption',
  templateUrl: './gift-voucher-redemption.component.html',
  styleUrls: ['./gift-voucher-redemption.component.scss']
})
export class GiftVoucherRedemptionComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy, AfterViewChecked {

  hidePayButton: boolean = true;
  showPayPal: boolean;

  giftVoucherNumber1: string;
  giftVoucherNumber2: string;

  public totalAmount: number = 0;
  public amountAvailable: number = 0;
  public redeemedAmount: number = 0;
  public payableUsingPayPal: number = 0;

  public order: PlaceOrderViewModel;
  public computedOrder: any;

  ngOnInit(): void {
    this.app.storageService.removeItem(AppConstants.BookingResultFailedToHoldGv);
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  ngAfterViewInit(): void {
    this.baseTriggerChild.subscribe(event => {
      this.app.spinner.show();
      if (this.app.stringService.isEmpty(this.app.basketItems==null || this.app.basketItems.length==0)) {
        this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.SelectedTreatment.toString());
        this.showErrorMessage('Please select a Treatment');
        this.app.router.navigate([AppConstants.RouteSelectConsultation]);
        return;
      }
      this.app.reCompute();
      this.app.spinner.hide();
    });

    this.start();
  }

  ngOnDestroy(): void {
    this.removeRefreshEvent();
  }

  addRefreshEvent(): void {
    window.addEventListener('keydown', (event) => {
      if (event.key === 'F5') {
        alert('We are processing your transaction, please wait.');
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }

  removeRefreshEvent(): void {
    window.removeEventListener('keydown', (event) => { });
    window.removeEventListener
  }

  back(): void {
    this.app.storageService.removeItem(AppConstants.Appointment);
    this.app.router.navigate([AppConstants.RouteSelectDate]);
  }


  validate() {
    this.amountAvailable = 0;
    this.redeemedAmount = 0;

    this.checkVoucherisNotEmpty();
    if (this.giftVoucherNumber1 == this.giftVoucherNumber2) {
      this.showErrorMessage('gift voucher must not be the same');
      return;
    }

    if (this.vouchersisNotEmpty) {
      var isNotValidateVoucher = false;

      var giftVouchers = new Array<ValidateGiftVoucherByNumberBindingModel>();

      if (this.app.stringService.isNotEmpty(this.giftVoucherNumber1)) {
        var model = new ValidateGiftVoucherByNumberBindingModel;
        model.giftVoucherNumber = this.giftVoucherNumber1;
        giftVouchers.push(model);
      }

      if (this.app.stringService.isNotEmpty(this.giftVoucherNumber2)) {
        var model = new ValidateGiftVoucherByNumberBindingModel;
        model.giftVoucherNumber = this.giftVoucherNumber2;
        giftVouchers.push(model);
      }
      this.app.spinner.show();
      this.app.webBookingService.ValidateGiftVoucherByNumber(giftVouchers)
        .subscribe(data => {
          this.app.spinner.hide();

          data.forEach(element => {
            this.amountAvailable += element.remainingAmount;
          });

          this.computeOrder();

        }, response => {
          this.app.spinner.hide();
          this.showErrorMessage(response);
          isNotValidateVoucher = true;
        });
    }
  }

  vouchersisNotEmpty: boolean = false

  //#endregion Transaction
  computeOrder(): void {
    const model: ComputeOrderBindingModel = new ComputeOrderBindingModel();
    model.branchId = this.app.branch.branchId;
    model.customerId = this.app.customer.customerId;

    model.items = this.app.basketItems;

    const payment: Payment = new Payment();
    payment.paymentTypeGroupId = PaymentTypeGroup.Web;
    model.payments = new Array<Payment>();
    model.payments.push(payment);

    model.enableDepositRequired = this.app.customer.isNewCustomer || this.app.customer.is2YearLastTransaction;

    this.app.webBookingService.ComputeOrder(model)
      .subscribe(
        data => {
          this.computedOrder = data;
          this.placeOrder();
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  placeOrder(): void {
    const model: PlaceOrderBindingModel = new PlaceOrderBindingModel();
    model.branchId = this.app.branch.branchId;
    model.customerId = this.app.customer.customerId;

    model.items = this.app.basketItems;

    model.payments = new Array<Payment>();
    if (this.app.stringService.isNotEmpty(this.giftVoucherNumber1)) {
      var payment = new Payment;
      payment.paymentTypeGroupId = PaymentTypeGroup.GiftVoucher;
      payment.giftVoucherNumber = this.giftVoucherNumber1;
      model.payments.push(payment);
    }
    if (this.app.stringService.isNotEmpty(this.giftVoucherNumber2)) {
      var payment = new Payment;
      payment.paymentTypeGroupId = PaymentTypeGroup.GiftVoucher;
      payment.giftVoucherNumber = this.giftVoucherNumber2;
      model.payments.push(payment);
    }
    if (model.payments.length == 0) {
      var payment: Payment = new Payment();
      payment.paymentTypeGroupId = PaymentTypeGroup.Web;
      model.payments.push(payment);
    }

    model.enableDepositRequired = this.app.customer.isNewCustomer || this.app.customer.is2YearLastTransaction;

    this.app.webBookingService.PlaceOrder(model)
      .subscribe(
        data => {
          this.order = data;
          this.app.storageService.setItem(AppConstants.PendingTransaction, JSON.stringify(data));
          
          this.totalAmount = data.subTotal;

          if (this.totalAmount > this.amountAvailable) this.redeemedAmount = this.amountAvailable;
          else this.redeemedAmount = this.totalAmount

          if (this.order.onlinePaymentAmountToBePaid > 0) {
            this.hidePayButton = true;
            this.payableUsingPayPal = this.order.onlinePaymentAmountToBePaid;
            this.createPayPalButton();
            return;
          }
          else
          {            
            this.payableUsingPayPal = 0;
            document.getElementById("paypal-button-container").innerHTML = '';
          }
          
          this.hidePayButton = false;

        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }
  //#endregion

  checkVoucherisNotEmpty() {
    if (this.app.stringService.isNotEmpty(this.giftVoucherNumber1)) {
      this.vouchersisNotEmpty = true;
    }

    if (this.app.stringService.isNotEmpty(this.giftVoucherNumber2)) {
      this.vouchersisNotEmpty = true;
    }
  }

  //#region Paypal Button
  createPayPalButton(): void {
    let clientId: string;
    if (this.app.config.payPalPaymentMode === 'sandbox') {
      clientId = this.app.config.payPalSandboxCliendId;
    }
    else if (this.app.config.payPalPaymentMode === 'production') {
      clientId = this.app.config.payPalProductionCliendId;
    }
    this.loadExternalScript('https://www.paypal.com/sdk/js?currency=' + this.app.config.payPalCurrencyCode + '&client-id=' + clientId);
  }

  loadExternalScript(scriptUrl: string): any {
    const scriptElement = document.createElement('script');
    scriptElement.src = scriptUrl;
    scriptElement.addEventListener('load', () => {
      this.loadPayPalSmartPaymentButton();
    });
    scriptElement.addEventListener('error', (e) => {
      this.showErrorMessage('PayPal online payment loading failed.');
      this.showPayPal = false;
    });
    document.body.appendChild(scriptElement);
    setTimeout(() => {
      this.app.spinner.hide();
    }, 3000);
  }

  loadPayPalSmartPaymentButton(): void {
    paypal.Buttons({
      style: {
        layout: 'horizontal',
        tagline: false
      },
      onClick: (data, actions) => {
        this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.ConfirmAppointment.toString());
        this.addRefreshEvent();
        return true;
      },
      createOrder: (data, actions) => {
        return actions.order.create({
          purchase_units: [{
            amount: {
              value: this.order.onlinePaymentAmountToBePaid
            }
          }]
        });
      },

      onApprove: (data, actions) => {
        this.app.spinner.show();

        // cset trabsaction as paid online
        const setTransactionAsPaidOnlineBindingModel = {
          customerId: this.app.customer.customerId,
          pendingTransactionId: this.order.pendingTransactionId,
          onlinePaymentTransactionId: data.orderID
        };
        this.order.onlineOrderId = data.orderID;
        this.app.storageService.setItem(AppConstants.PendingTransaction, JSON.stringify(this.order));
        this.app.webBookingService.SetTransactionAsPaidOnline(setTransactionAsPaidOnlineBindingModel).subscribe(
          () => {          

             // proceed paypal payment
             return actions.order.capture().then(
              payment => {
                // Show a success message to your buyer
                const commitPaymentBindingModel = {
                  customerId: this.app.customer.customerId,
                  onlinePaymentTransactionId: payment.id,
                  pendingTransactionId: this.order.pendingTransactionId,
                };
                this.app.webBookingService.CommitPayment(commitPaymentBindingModel).subscribe(
                  () => {
                    // Send Transaction to email.
                    const model = new SendTransactionToEmailBindingModel();
                    model.customerId = this.app.customer.customerId;
                    model.pendingTransactionId = this.order.pendingTransactionId;
                    model.token = JSON.parse(this.app.storageService.getItem(AppConstants.Token)).access_token,
                      this.app.webBookingService.SendTransactionToEmail(model).subscribe(
                        () => {
                          this.getProfile();
                          // this ngzone will fix the warning issue: core.js:3126
                          // Navigation triggered outside Angular zone, did you forget to call 'ngZone.run()'?
                          this.app.ngZone.run(() => {
                            this.saveAppointmentResult();
                          });
                          this.app.spinner.hide();
                        },
                        error => {
                          this.showErrorMessage(error);
                          this.app.spinner.hide();
                        }
                      );
                  },
                  error => {
                    this.showErrorMessage(error);
                    this.app.spinner.hide();
                  }
                );

              },
              error => {
                this.showErrorMessage(error);
                this.app.spinner.hide();
                return;
              });
              
          },
          error => {
            this.showErrorMessage(error);
            this.app.spinner.hide();
          });
      },

      onCancel: (data, actions) => {
        return;
      },

      onError: (data, actions) => {
        return;
      }
    }).render('#paypal-button-container');
  }

  pay() {
    this.app.spinner.show();
    const model = {
      pendingTransactionId : this.order.pendingTransactionId,
      customerId : this.app.customer.customerId
    };    
    this.app.webBookingService.SetTransactionAsPaidOnlineByGv(model)
      .subscribe((data) => {
        this.commit();
      }, (error) => {
        this.app.addLogs('Commit Payment', error);
        this.app.spinner.hide();
        this.app.showErrorMessage(error);
        this.app.storageService.setItem(AppConstants.GiftVoucherProcessStatus, ProcessStatus.Result.toString());
        this.app.router.navigate([AppConstants.RouteInvalid]);
      });
  }

  commit()
  {
    const model = {
      pendingTransactionId : this.order.pendingTransactionId,
      customerId : this.app.customer.customerId,
      token : JSON.parse(this.app.storageService.getItem(AppConstants.Token)).access_token
    };    
    this.app.webBookingService.CommitPayment(model)
      .subscribe((data) => {
        this.app.spinner.hide();
        this.app.webBookingService.SendTransactionToEmail(model).subscribe();
        this.saveAppointmentResult();
      }, (error) => {
        this.app.addLogs('Commit Payment', error);
        this.app.spinner.hide();
        this.app.showErrorMessage(error);
        this.app.storageService.setItem(AppConstants.GiftVoucherProcessStatus, ProcessStatus.Result.toString());
        this.app.router.navigate([AppConstants.RouteInvalid]);
      });
  }

  getProfile(): void {
    this.app.webBookingService.GetProfile()
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.app.customer = data;
          this.app.storageService.setItem(AppConstants.Customer, JSON.stringify(this.app.customer));
          this.checkCustomerData();
        },
        error => {
          this.app.spinner.hide();
          this.app.router.navigate([AppConstants.RouteSelectConsultation]);
        });
  }

  goBackToPreviousPage() {
    this.app.router.navigate([AppConstants.RouteCheckout]);
  }

  saveAppointmentResult(): void {
    this.app.storageService.setItem(AppConstants.BookingTreatmentResult, JSON.stringify(this.app.basketItems));
    this.app.storageService.setItem(AppConstants.BookingSlotResult, this.app.storageService.getItem(AppConstants.BookingSelectedTime));
    this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.Result.toString());
      
    this.app.storageService.removeItem(AppConstants.Appointment);
    this.app.storageService.removeItem(AppConstants.RedirectState);
    this.app.storageService.removeItem(AppConstants.PendingTransaction);
    this.app.storageService.removeItem(AppConstants.BookingSelectedDate);
    this.app.storageService.removeItem(AppConstants.BookingSelectedSlot);
    this.app.storageService.removeItem(AppConstants.BookingSelectedTime);
    this.app.storageService.removeItem(AppConstants.SelectedPractitioner);
    this.app.storageService.removeItem(AppConstants.BookingSelectedTreatment);
    this.app.storageService.removeItem(AppConstants.BookingGiftVoucherNumber);
    this.app.storageService.removeItem(AppConstants.GiftVoucherSelectedVouchers);
    
    this.app.basketItems = [];  
    this.app.reCompute();

    this.app.router.navigate([AppConstants.RouteGvThankYou]);
  }
  //#endregion

}
